import React from 'react'

const NotificationInbox = () => {
  return (
    <div>
      <h1>NotificationRule</h1>
    </div>
  )
}

export default NotificationInbox
